// sections/PaymentMethodSection/StandardRow.tsx — Baris radio metode standar.
import React from 'react';
import { PAYMENT_CONFIG } from '../../../../constants/formViewer';
import { formatMoney } from '../../../../utils/formatMoney';
import { ms } from '../../../../locales/ms';
import { ROW_BASE, ROW_IDLE, ROW_ACTIVE, LOGO_SLOT, stdIconClass } from './rowClasses';

export const StandardRow: React.FC<{
    payKey: string; form: any; isMY: boolean; selectedPaymentKey: unknown;
    setSelectedPaymentKey: (v: any) => void; setSelectedDuitkuMethod: (v: any) => void;
    lineSubtotal: number; shippingCost: number;
}> = ({ payKey, form, isMY, selectedPaymentKey, setSelectedPaymentKey, setSelectedDuitkuMethod, lineSubtotal, shippingCost }) => {
    const config = (PAYMENT_CONFIG as any)[payKey];
    if (!config) return null;
    const Icon = config.icon;
    const isCodKey = ['cod', 'codJawaBali', 'codLuarJawaBali'].includes(payKey);
    const codSetting = isCodKey ? (form.paymentSettings[payKey] as any) : null;
    const codFeePreview = isCodKey && codSetting?.handlingFeePercentage ? ((codSetting.handlingFeePercentage / 100) * (codSetting.handlingFeeBase === 'product_and_shipping' ? lineSubtotal + shippingCost : lineSubtotal)) : 0;
    return (<div>
        <label className={ROW_BASE + (selectedPaymentKey === payKey ? ROW_ACTIVE : ROW_IDLE)}>
            <input type="radio" name="paymentMethod" value={payKey} checked={selectedPaymentKey === payKey} onChange={() => { setSelectedPaymentKey(payKey); setSelectedDuitkuMethod(null); }} className="h-4 w-4 text-orange-600" />
            <span className={LOGO_SLOT}><Icon className={stdIconClass(Icon)} /></span>
            <div className="flex-1"><span className="font-medium">{isCodKey && isMY ? ms(form, m => m.codLabel, config.label) : config.label}</span>{isCodKey && codFeePreview > 0 && <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">+ Biaya COD {formatMoney(Math.round(codFeePreview), form)} ({codSetting?.handlingFeePercentage}%)</p>}</div>
        </label>
    </div>);
};
